
const Footer = () => {
  return (
    <div>
        <div className='w-full py-3 flex justify-center bg-black'>
            <h4 className='text-white'>&copy;2024 by Kopilibrasi.web.id</h4>
        </div>
    </div>
  )
}

export default Footer